import { PropertyInfoInterface } from "src/managers/PropertyInfoInterface";
import { IdentTransformer, PropertyDataRequestsObj } from "./PropertyInfoCollectorTypes";
import { ObliqueInterfaces } from "src/managers/ObliqueInterfaces";
import { ViewDirection } from "src/managers/ObliqueFunc";
import { BuildingHeight } from "src/managers/BuildingHeight";
import { GenerateGeom } from "src/managers/GenerateGeom";
import { MarkData } from "src/components/MarkData";
import { DC } from "src/dataCollector/DataCollector";

export const IdentTransformers: IdentTransformer[] = [

];

export const RequestObject: PropertyDataRequestsObj = {
  Mat2Ejerlejlighed: {
    identDependency: "BFEnr",
    paramTransformer(ident) {
      if ("BFEnr" in ident) {
        return [ident.BFEnr]
      }
      return []
    },
    func: PropertyInfoInterface.Ejerlejligheder,
    returnTransformer(result) {
      return result.features.map((a) => a.properties)
    },
    hasThis: PropertyInfoInterface,
  },
  ESearchEjerlejlighed: {
    dependency: "Mat2Ejerlejlighed",
    paramTransformer(ident, data) {
      if (data && "Mat2Ejerlejlighed" in data) {
        return data.Mat2Ejerlejlighed.flat().map((a) => {
          return [a.BFEnummer]
        }).filter((a) => a.length)
      }
      return []
    },
    func: PropertyInfoInterface.ejerAfEjerlejlighed,
    returnTransformer(a) {
      return a[0]
    }
  },
  SFEGeom: {
    identDependency: "BFEnr",
    paramTransformer(ident) {
      if ("BFEnr" in ident) {
        return [ident.BFEnr];
      } return [];
    },
    func: PropertyInfoInterface.fetchMat2CadasterWFSForSFE,
    hasThis: PropertyInfoInterface,
    returnTransformer(result) {
      return result
    }
  },
  BBRRel: {
    identDependency: "BFEnr",
    paramTransformer(ident) {
      if (ident["BFEnr"]) return [(ident as any).BFEnr];
      return [];
    },
    func: PropertyInfoInterface.BBRejendomsrelationForBFE,
    hasThis: PropertyInfoInterface,
    returnTransformer(result) {
      return result[0];
    },
  },
  ViamapTingBog: {
    identDependency: "BFEnr",
    paramTransformer(ident) {
      if (ident["BFEnr"]) { return [ident["BFEnr"]] }
      return []
    },
    func: PropertyInfoInterface.getDataTingbogByBFE,
    hasThis: PropertyInfoInterface,
    returnTransformer(a) {
      return a
    }
  },
  ViamapEjendomData: {
    identDependency: "BFEnr",
    paramTransformer(ident) {
      if ("BFEnr" in ident) return [ident.BFEnr];
      return [];
    },
    func: DC.DLL.EjendomData,
    returnTransformer(result) {
      return result;
    },
  },
  ViamapHandelsOplysning: {
    identDependency: "BFEnr",
    paramTransformer(ident) {
      if ("BFEnr" in ident) return [ident.BFEnr];
      return [];
    },
    func: DC.DLL.EjendomHandel,
    returnTransformer(result) {
      return result;
    },
  },
  GQL_BFE: {
    identDependency: "BFEnr",
    paramTransformer(ident) {
      if ("BFEnr" in ident) return [ident.BFEnr];
      return [];
    },
    func: DC.DF_GQL.Mat2.BestemtFastEjendom,
    hasThis: DC.DF_GQL.Mat2,
    returnTransformer(result) {
      return result;
    }
  },
  GQL_EBRBFE: {
    identDependency: "BFEnr",
    paramTransformer(ident) {
      if ("BFEnr" in ident) return [ident.BFEnr];
      return [];
    },
    func: DC.DF_GQL.EBR.EjendomsbeliggenhedForBFE,
    hasThis: DC.DF_GQL.EBR,
    returnTransformer(result) {
      return result;
    }
  },
  EBRAdresseOgPunkt: {
    identDependency: "BFEnr",
    paramTransformer(ident) {
      if ("BFEnr" in ident) return [ident.BFEnr];
      return [];
    },
    func: DC.DF_GQL.EBR.EBRAdresseOgPunkt,
    hasThis: DC.DF_GQL.EBR,
    returnTransformer(result) {
      return result;
    }
  },
  PlanDataDelområde: {
    dependency: "SFEGeom",
    paramTransformer(_ident, data) {
      if (data && "SFEGeom" in data) {
        return [data.SFEGeom, "theme_pdk_lokalplandelomraade_vedtaget_version"];
      }
      return [];
    },
    func: DC.WFS.Utils.PlanData,
    returnTransformer: (a) => a,
  },
  PlanDataLokalPlan: {
    dependency: "SFEGeom",
    paramTransformer(_ident, data) {
      if (data && "SFEGeom" in data) {
        return [data.SFEGeom, "theme_pdk_lokalplan_vedtaget"];
      }
      return [];
    },
    func: DC.WFS.Utils.PlanData,
    returnTransformer: (a) => a,
  },
  PlanDataKommunePlan: {
    dependency: "SFEGeom",
    paramTransformer(_ident, data) {
      if (data && "SFEGeom" in data) {
        return [data.SFEGeom, "theme_pdk_kommuneplanramme_alle_vedtaget_v"];
      }
      return [];
    },
    func: DC.WFS.Utils.PlanData,
    returnTransformer: (a) => a,
  },
  PlanDataKommunePlanAflyst: {
    dependency: "SFEGeom",
    paramTransformer(_ident, data) {
      if (data && "SFEGeom" in data) {
        return [data.SFEGeom, "theme_pdk_kommuneplanramme_alle_aflyst_v"];
      }
      return [];
    },
    func: DC.WFS.Utils.PlanData,
    returnTransformer: (a) => a,
  },
  PlanDataKommunePlanForslag: {
    dependency: "SFEGeom",
    paramTransformer(_ident, data) {
      if (data && "SFEGeom" in data) {
        return [data.SFEGeom, "theme_pdk_kommuneplanramme_alle_forslag_v"];
      }
      return [];
    },
    func: DC.WFS.Utils.PlanData,
    returnTransformer: (a) => a,
  },
  PlanDataLokalPlanAflyst: {
    dependency: "SFEGeom",
    paramTransformer(_ident, data) {
      if (data && "SFEGeom" in data) {
        return [data.SFEGeom, "theme_pdk_lokalplan_aflyst"];
      }
      return [];
    },
    func: DC.WFS.Utils.PlanData,
    returnTransformer: (result) => result,
  },
  PlanDataLokalPlanForslag: {
    dependency: "SFEGeom",
    paramTransformer(_ident, data) {
      if (data && "SFEGeom" in data) {
        return [data.SFEGeom, "theme_pdk_lokalplan_forslag"];
      }
      return [];
    },
    func: DC.WFS.Utils.PlanData,
    returnTransformer: (result) => result,
  },
  DHM_Overflade: {
    dependency: "EBRAdresseOgPunkt",
    paramTransformer(ident, data) {
      if (data && "EBRAdresseOgPunkt" in data) {
        console.log("Transforming EBRAdresseOgPunkt to DHM_Overflade with data:", data.EBRAdresseOgPunkt);
        if (data.EBRAdresseOgPunkt?.[0]?.lat && data.EBRAdresseOgPunkt[0]?.lng) {
          let y = GenerateGeom.convertFromLatLngToUTM({
            lat: data.EBRAdresseOgPunkt[0].lat,
            lng: data.EBRAdresseOgPunkt[0].lng,
          });
          return [y];
        }
      }
      return [];
    },
    func: BuildingHeight.getHeightInformationLocalMaximum,
    returnTransformer(result) {
      return result;
    },
    hasThis: BuildingHeight,
  },
  Marker: {
    dependency: "SFEGeom",
    paramTransformer(ident, data) {
      if (data && "SFEGeom" in data) {
        return [data.SFEGeom];
      }
      return [];
    },
    func: MarkData.hentMarkerIndenforFeatureCollection,
    returnTransformer(result) {
      return result;
    },
    hasThis: MarkData,
  },
  DHM_Terraen: {
    dependency: "EBRAdresseOgPunkt",
    paramTransformer(ident, data) {
      if (data && "EBRAdresseOgPunkt" in data) {
        if (data.EBRAdresseOgPunkt?.[0]?.lat && data.EBRAdresseOgPunkt[0]?.lng) {
          let y = GenerateGeom.convertFromLatLngToUTM({
            lat: data.EBRAdresseOgPunkt[0].lat,
            lng: data.EBRAdresseOgPunkt[0].lng,
          });
          return [y];
        }
      }
      return [];
    },
    func: BuildingHeight.getHeightInformation,
    returnTransformer(result) {
      return result;
    },
    hasThis: BuildingHeight,
  },
  ViamapEjendomStats: {
    dependency: ["ViamapEjendomData"],
    paramTransformer(ident, data) {
      if (
        data?.ViamapEjendomData
      )
        return [
          Number(data.ViamapEjendomData.kommuneNr).toString(),
          Number(data.ViamapEjendomData.postNr).toString(),
          1,
        ];
      return [];
    },
    func: PropertyInfoInterface.getEjendomStats,
    hasThis: PropertyInfoInterface,
    returnTransformer(result) {
      return result.Samlet;
    },
  },
  PEnheder: {
    dependency: ["Mat2", "BBRSFE"],
    paramTransformer(ident, data) {
      let matrikler = data?.BBRSFE?.[0]?.properties.jordstykke.map((js) => {
        let item = js.properties;
        return {
          ejerlavkode: item.ejerlavskode,
          matrikelnr: item.matrikelnummer,
          ejerlavsnavn: item.ejerlavsnavn
        }
      })
      if (matrikler && matrikler.length > 0) {
        return [[matrikler]];
      }
      return [];
    },
    func: PropertyInfoInterface.PEnhederpaaEjendom,
    hasThis: PropertyInfoInterface,
    returnTransformer(result) {
      return result;
    },
  },
  MatEjerlejlighed: {
    identDependency: "BFEnr",
    paramTransformer(ident) {
      if (ident["BFEnr"]) { return [ident["BFEnr"]] }
      return []
    },
    func: PropertyInfoInterface.EjerlejlighederEnkelt,
    hasThis: PropertyInfoInterface,
    returnTransformer(a) {
      return a.features[0].properties
    }
  },
  Vurd: {
    identDependency: "BFEnr",
    paramTransformer(ident) {
      if ("BFEnr" in ident) return [ident.BFEnr];
      return [];
    },
    func: DC.VURD.vurdLookupByBfeNr,
    hasThis: PropertyInfoInterface,
    returnTransformer(result) {
      return result;
    },
  },
  ViamapEjerskab: {
    identDependency: "BFEnr",
    paramTransformer(ident) {
      if (ident["BFEnr"]) { return [ident["BFEnr"]] }
      return []
    },
    func: DC.DLL.EjendomEjerskab,
    returnTransformer(a) {
      return a
    }
  },
  GQL_VURD: {
    identDependency: "BFEnr",
    paramTransformer(ident) {
      if (ident["BFEnr"]) { return [ident["BFEnr"]] }
      return []
    },
    func: DC.DF_GQL.VURD.VurdFromBFE,
    hasThis: DC.DF_GQL.VURD,
    returnTransformer(a) {
      return a
    }
  },
  GQL_BBR: {
    identDependency: "BFEnr",
    paramTransformer(ident) {
      if (ident["BFEnr"]) { return [ident["BFEnr"]] }
      return []
    },
    func: DC.DF_GQL.BBR.BygOgEnheder,
    hasThis: DC.DF_GQL.BBR,
    returnTransformer(a) {
      return a
    }
  },
  EnergyLabel: {
    identDependency: "BFEnr",
    paramTransformer(ident) {
      if ("BFEnr" in ident) {
        return [ident.BFEnr];
      }
      return [];
    },
    func: PropertyInfoInterface.getEnergyLabelData,
    hasThis: PropertyInfoInterface,
    returnTransformer(result) {
      return {
        EnergyLabels: result.EnergyLabels,
        ResponseStatus: result.ResponseStatus,
      };
    }
  }
};
